import React, { Component } from 'react';
import { } from 'react-bootstrap'
import { connect } from 'react-redux'
import { fetchSearchInput, fetchProducts } from '../actions'
class CategoryItem extends Component {
    state = {
        imgLoaded: false
    }
    onClick() {
        this.props.fetchSearchInput(this.props.subcat.name_th)
        this.props.fetchProducts(this.props.subcat.name_th)
        this.props.history.push(`/search/${this.props.subcat.name_th}`)
    }
    render() {
        return (
            <div>
                <img className="imgpromotion" style={this.state.imgLoaded ? { padding: 3, cursor: 'pointer', width: 100 + '% !important' } : { display: 'none', width: 100 + '% !important' }} onLoad={() => { this.setState({ imgLoaded: true }) }} src={this.props.subcat.img_url} onClick={() => { this.onClick() }} />
                <img style={!this.state.imgLoaded ? { padding: 3, width: 100 + '% !important' } : { display: 'none', width: 100 + '% !important' }} src='../../static/images/placeholdercat.jpg' />
            </div>
        )
    }
}
export default connect(null, { fetchSearchInput, fetchProducts })(CategoryItem)


// WEBPACK FOOTER //
// ./src/components/category_item.js